<!--
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2024-03-05 17:39:11
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2024-03-13 09:35:42
 * @FilePath: /chaoyongtuan/src/views/shopManage/shopLibrary/addMaterial/components/good/tableCells/materialInfoCell.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div class="flex flex-align-center">
		<el-image style="width: 32px; height: 32px; margin-right: 6px; border-radius: 4px" :src="row.productPic">
			<template v-slot:error>
				<img src="@/assets/public/img-empty1.png" alt="" />
			</template>
		</el-image>
		<div>
			<rdShopInfo
				:shopInfo="{ name: row.goodsInfo.productName }"
				:showShopIcon="true"
				:platformId="row.goodsInfo.platformId"
				:textWidth="260"
			></rdShopInfo>
			<rdText label="ID" :showCopy="false" :useByTable="false">{{ row.goodsInfo.thirdProductId }}</rdText>
			<div class="fz-12 active-color" v-if="column.commissionShow">公开佣金率{{ row.commissionRate }}%</div>
		</div>
	</div>
</template>
<script>
import mixin from '@/components/tableCells/mixin.js';
export default {
	mixins: [mixin],
	data() {
		return {};
	},

	computed: {},
	props: {},

	mounted() {},

	methods: {},
};
</script>
<style lang="less" scoped>
.active-color {
	color: #2475ff;
}
</style>
